import React from 'react';

// Utility to format date from 'YYYY-MM-DD+05:30' to 'DD/MM/YYYY'
const formatDate = (dateStr) => {
  if (!dateStr) return '';
  try {
    const cleanDate = dateStr.split('+')[0];
    const d = new Date(cleanDate);
    if (isNaN(d.getTime())) return dateStr;
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  } catch {
    return dateStr;
  }
};

// Utility to format amount to Indian Rupee format
const formatCurrency = (val) => {
  if (!val || val === '-1' || val === '') return '₹ 0';
  const num = Number(val);
  if (isNaN(num)) return val;
  return `₹ ${num.toLocaleString('en-IN')}`;
};

// Map inquiry type symbol to description
const getEnquiryPurpose = (symbol) => {
  const map = {
    '01': 'Auto Loan',
    '02': 'Housing Loan',
    '03': 'Property Loan',
    '04': 'Business Loan',
    '05': 'Personal Loan',
    '06': 'Consumer Loan',
    '08': 'Auto Loan (Personal)',
    '10': 'Credit Card',
    '99': 'Others'
  };
  return map[symbol] || 'Others';
};

export default function ConsumerEnquiryDetails({ enquiries = [], name }) {
  // Demo fallback array if no enquiries are passed as props
  const enquiryList = enquiries.length > 0 ? enquiries : [];

  return (
    <div className="w-full max-w-5xl mx-auto font-sans px-4 pb-4 print:p-0 min-h-screen">
      {/* SECTION HEADER */}
      {/* <h2 className="text-2xl font-bold text-gray-900 mb-6 uppercase tracking-wide">
        CONSUMER ENQUIRY DETAILS
      </h2> */}

     {/* SECTION TITLE */}
      <h2 className="text-base text-gray-500 mb-1 font-medium uppercase tracking-wide">
        ENQUIRIES:
      </h2>

      {/* TABLE CONTAINER */}
      <div className="border-b pb-2  border-gray-800 rounded-sm overflow-hidden">
        <table className="w-full text-left border-collapse">
          
          {/* TABLE HEAD */}
          <thead>
            <tr className=" ">
              <th className="py-2 px-4 text-[10px] font-medium text-[#008c95] uppercase w-1/4">
                MEMBER
              </th>
              <th className="py-2 px-4 text-[10px] font-medium text-[#008c95] uppercase w-1/4">
                ENQUIRY DATE
              </th>
              <th className="py-2 px-4 text-[10px] font-medium text-[#008c95] uppercase w-1/4">
                ENQUIRY PURPOSE
              </th>
              <th className="py-2 px-4 text-[10px] font-medium text-[#008c95] uppercase w-1/4">
                ENQUIRY AMOUNT
              </th>
            </tr>
          </thead>

          {/* TABLE BODY */}
          <tbody>
            {enquiryList?.length > 0 && enquiryList.map((item, index) => {
              const data = item?.Inquiry || {};
              
              return (
                <tr 
                  key={index} 
                  className="odd:bg-[#e4e3e3]   last:border-0"
                >
                  <td className="py-1 px-4 text-[10px] font-medium text-gray-900 uppercase">
                    {/* Falling back to "NOT DISCLOSED" if name is missing to match image layout behavior, though your JSON provides the name */}
                    {data.subscriberName || 'NOT DISCLOSED'}
                  </td>
                  <td className="py-1 px-4 text-[10px] font-medium text-gray-900 uppercase">
                    {formatDate(data.inquiryDate)}
                  </td>
                  <td className="py-1 px-4 text-[10px] font-medium text-gray-900">
                    {getEnquiryPurpose(data.inquiryType)}
                  </td>
                  <td className="py-1 px-4 text-[10px] font-medium text-gray-900 uppercase">
                    {data.amount}
                  </td>
                </tr>
              );
            })}
            
            {enquiryList.length === 0 && (
              <tr>
                <td colSpan="4" className="py-6 text-center text-gray-800 font-bold bg-[#c4c5c5]">
                  NO ENQUIRIES FOUND
                </td>
              </tr>
            )}
          </tbody>

        </table>
      </div>


      <div className="w-full mt-[300px] max-w-5xl mx-auto py-6 font-sans text-[10px] print:p-0">
  {/* Header */}
  <h2 className="text-[#00a1de] text-[12px] font-bold uppercase tracking-wider mb-3">
    END OF REPORT ON {name || "N/A"}
  </h2>

  {/* Thin Top Border */}
  <hr className="border-t border-gray-400 mb-4" />

  {/* Disclaimer Paragraph */}
  <p className="text-black font-medium leading-relaxed mb-4 text-justify">
    All information contained in this credit report has been collated by
    TransUnion CIBIL Limited (TU CIBIL) based on information provided /
    submitted by its various members ("Members"), as part of periodic data
    submission and Members are required to ensure accuracy, completeness and
    veracity of the information submitted. The credit report is generated using
    the proprietary search and match logic of TU CIBIL. TU CIBIL uses its best
    efforts to ensure accuracy, completeness and veracity of the information
    contained in the Report, and shall only be liable and / or responsible if
    any discrepancies are directly attributable to TU CIBIL. The use of this
    report is governed by the terms and conditions of the Operating Rules for TU
    CIBIL and its Members.
  </p>

  {/* Thick Cyan Bottom Border */}
  <hr className="border-t-[3px] border-[#00a1de] mb-3" />

  {/* Footer */}
  <div className="text-center font-medium text-black leading-snug">
    <p>
      © 2018 TransUnion CIBIL Limited. (Formerly: Credit Information Bureau
      (India) Limited). All rights reserved
    </p>
    <p>TransUnion CIBIL CIN : U72300MH2000PLC128359</p>
  </div>
</div>
    </div>
  );
}

